// extracted by mini-css-extract-plugin
export default {"table":"components-hotel-net-revenue-cost-drilldown-section-module__table"};